import React from 'react'
import DashboardItem from './DashboardItem'

import * as s from './DashboardBlock.module.scss'
import HorizontalScrollSection from '../HorizontalScrollSection'

const DashboardBlock: React.FC = () => {
  return (
    <div className={s.container}>
      <HorizontalScrollSection />
      <DashboardItem />
    </div>
  )
}

export default DashboardBlock
